// formConfigurations.js
export const defaultFormDataMaison = {
  additionalComments: '',
  adresse: '',
  apartmentUsage: '',
  budgetRange: [80000, 250000],
  chambresSalonEquipe: false,
  ceilingHeight: 0,
  cuisineEquipe: false,
  dateNaissance: '',
  distanceToUrbanCenter: 0,
  email: '',
  familyComposition: '',
  garageMaison: '',
  healthServices: false,
  neighborProximity: false,
  neighborhoodType: '',
  nbrChambres: 0,
  otherViewPreferences: '',
  passport: '',
  pointEau: false,
  prenom: '',
  proximityBigCity: '',
  proximityMountains: '',
  publicMerProximity: '',
  purchaseDate: '',
  recreation: false,
  region: '',
  restrictions: '',
  schools: false,
  shops: false,
  styleMaison: '',
  surfaceMaison: [0, 0],
  surfaceRange: [100, 200],
  telephone: '',
  terrainSlope: '',
  terrainType: '',
  transports: false,
  userEmail: '',
  userEpay: false,
  userId: '',
  viabilise: false,
  vegetation: false,
  viewCity: false,
  viewCompagne: false,
  viewMountains: false,
  viewSea: false,
};
